/*
    Create by zhang.qiang 2016-11-21
*/
"use strict";
angular.module("trsSelectDocumentNewModule", [])
    .controller("trsSelectDocumentNewCtrl", ["$scope", "$validation", "$q", "$timeout", "$modalInstance", "modalDialog", "params", "trsHttpService", "$filter", "localStorageService", "websiteLeftService", function($scope, $validation, $q, $timeout, $modalInstance, modalDialog, params, trsHttpService, $filter, localStorageService, websiteLeftService) {
        initStatus();
        initData();
        /**
         * [initStatus description]初始化状态
         */
        function initStatus() {
            initRequired();
            $scope.status = {
                required: params.required,
                widgetParams: params.widgetParams,
                curChannelid: params.widgetParams.channelid,
                documentsMaxCount: 50,
                isSearch: false,
                selectedArray: {},
                titleTip: '收起',
                treeOptions: {
                    nodeChildren: "CHILDREN",
                    dirSelectable: true,
                    allowDeselect: false,
                    injectClasses: {
                        ul: "a1",
                        li: "a2",
                        liSelected: "a7",
                        iExpanded: "a3",
                        iCollapsed: "a4",
                        iLeaf: "a5",
                        label: "a6",
                        labelSelected: ""
                    },
                    isLeaf: function(node) {
                        return node.HASCHILDREN === "false";
                    }
                }
            };
            $scope.page = {
                PAGESIZE: angular.copy($scope.status.centerPageSize),
                CURRPAGE: 1,
            };
            initDropDownList();
        }
        /**
         * [initData description]初始化数据
         */
        function initData() {
            $scope.data = {
                selectedDocuments: params.docs,
                items: {}
            };
            $scope.loadingPromise = getTreeData().then(function() {
                $scope.status.curChannelid = $scope.selectedNode.CHANNELID;
                $scope.loadingPromise = requestData();
            });
        }
        /**
         * [cancel description]取消关闭窗口
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [pageChanged description]翻页
         */
        $scope.pageChanged = function() {
            $scope.loadingPromise = requestData();
        };
        /**
         * [jumpToPage description]跳页
         */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
            $scope.loadingPromise = requestData();
        };
        /**
         * [showToggle description]打开树节点
         */
        $scope.showToggle = function(node) {
            if (angular.isDefined(node.CHILDREN) && node.CHILDREN.length === 0 && node.HASCHILDREN === "true") {
                var childrenTreeParam = {
                    serviceid: "mlf_mediasite",
                    methodname: "queryClassifyByChnl",
                    ChannelId: node.CHANNELID,
                    platform: 1,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), childrenTreeParam, "get")
                    .then(function(data) {
                        node.CHILDREN = data.CHILDREN;
                    });
            }
        };
        /**
         * [cleanInput description]删除标题文字
         */
        $scope.cleanInput = function(item) {
            item.title = "";
        };
        /**
         * [fullTextSearch description]按条件检索
         */
        $scope.fullTextSearch = function() {
            $scope.status.isSearch = true;
            requestData();
        };
        /**
         * [showSelected description]选中树节点
         */
        $scope.showSelected = function(node) {
            memorySelectedChannel(node.CHANNELID);
            $scope.status.isSearch = false;
            $scope.page.CURRPAGE = 1;
            $scope.status.curChannelid = node.CHANNELID;
            $scope.loadingPromise = requestData(false);
        };
        /**
         * [showSelected description]选中树节点
         */
        $scope.showMe = function(item) {
            item.showMe = item.showMe == false ? true : false;
            $scope.status.titleTip = $scope.status.showMe ? '收起' : '展开';
        };
        /**
         * [checkChecked description]选中标记
         */
        $scope.checkChecked = function(item) {
            var flag = $scope.status.selectedMap[item.RECID];
            //为全选按钮构造标记开始
            if (flag) {
                $scope.status.selectedArray[item.RECID] = true;
            } else {
                delete $scope.status.selectedArray[item.RECID];
            }
            //为全选按钮构造标记结束
            return $scope.status.selectedMap[item.RECID];
        };
        /**
         * [selectDoc description]选中/取消选中稿件
         */
        $scope.selectDoc = function(item) {
            var flag = $scope.status.selectedMap[item.RECID];
            if (flag) deleteDoc(item);
            else selectDoc(item);
        };
        /**
         * [manualImport description]手工导入
         */
        $scope.manualImport = function() {
            var selectedDocuments = angular.copy($scope.data.selectedDocuments);
            delete $scope.data.selectedDocuments;
            $timeout(function() {
                $scope.data.selectedDocuments = selectedDocuments;
                $timeout(function() {
                    $validation.validate($scope.selectDocumentNewForm).success(function() {
                        if ($scope.data.selectedDocuments.length === $scope.status.documentsMaxCount) {
                            modalDialog.alertType("选择稿件数不能超过" + $scope.status.documentsMaxCount + "条", "", "warning", false);
                        }
                        $scope.data.selectedDocuments.unshift({
                            reltime: $filter('date')(new Date(), "yyyy-MM-dd HH:mm:ss").toString()
                        });
                    }).error(function() {
                        modalDialog.alertType("请先检查已选稿件填写项！", "", "warning", false);
                    });
                }, 10);
            }, 10);
        };
        /**
         * [openPuburl description]打开链接地址
         */
        $scope.openPuburl = function(item) {
            window.open(item.DOCPUBURL);
        };
        /**
         * [checkSelectedAll description]判断列表是否全选
         */
        $scope.checkSelectedAll = function() {
            var index = 0;
            for (var i in $scope.status.selectedArray) {
                index++;
            }
            var selectedCount = (angular.isDefined($scope.data) && angular.isDefined($scope.data.items) && angular.isDefined($scope.data.items.DATA)) ? $scope.data.items.DATA.length : 0;
            return index === selectedCount && index !== 0;
        };
        /**
         * [deleteDoc description]删除选中稿件
         */
        $scope.deleteDoc = function(item) {
            item.RECID = item.recid;
            deleteDoc(item);
        };
        /**
         * [selectAll description]全选或全部取消
         */
        $scope.selectAll = function() {
            $scope.loadingPromise = selectAll();
        };
        /**
         * [confirm description]确认提交
         */
        $scope.confirm = function() {
            /*console.log($scope.data.selectedDocuments);*/
            var selectedDocuments = angular.copy($scope.data.selectedDocuments);
            delete $scope.data.selectedDocuments;
            $timeout(function() {
                $scope.data.selectedDocuments = selectedDocuments;
                $timeout(function() {
                    $validation.validate($scope.selectDocumentNewForm).success(function() {
                        $modalInstance.close(angular.copy($scope.data.selectedDocuments));
                    }).error(function() {
                        modalDialog.alertType("请先检查已选稿件填写项！", "", "warning", false);
                    });
                }, 10);
            }, 20);
        };
        /**
         * [initRequired description]初始化required，数组转对象
         */
        function initRequired() {
            var required = {};
            for (var i = 0; i < params.required.length; i++) {
                var key = params.required[i];
                required[key] = true;
            }
            params.required = required;
        }
        /**
         * [requestData description]获取列表数据
         * @param  {[boolean]} requestData   [description] 是否按条件搜索
         */
        function requestData() {
            var deffer = $q.defer();
            setSearchOptioin();
            var params = {
                "serviceid": "mlf_metadata",
                "methodname": "queryMetaByChannel",
                "IsPicDoc": false,
                "PageSize": 15,
                "CurrPage": $scope.page.CURRPAGE,
                "ChannelId": $scope.status.curChannelid,
                "IsCurrentChnl": false,
                "SearchDocId": "",
                "SearchRecId": $scope.status.SearchRecId,
                "SearchTitle": $scope.status.SearchTitle
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get")
                .then(function(data) {
                    $scope.data.items = data;
                    $scope.page = data.PAGER;
                    $scope.status.copyCurrPage = data.PAGER.CURRPAGE;
                    initSelectedMap();
                    deffer.resolve(data);
                }, function(){
                    console.log(a);
                });
            return deffer.promise;
        }
        /**
         * [getTreeData description]获取左侧树数据
         */
        function getTreeData() {
            var deffer = $q.defer();
            var params = {
                serviceid: "mlf_mediasite",
                methodname: "queryClassifyBySite",
                SiteId: $scope.status.widgetParams.siteid,
                platform: 1,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.data.siteDesc = data.SITEDESC;
                $scope.data.treeData = data.CHILDREN;
                var memoryChannelid = localStorageService.get("selectDocumentChannelMemory");
                if (memoryChannelid !== null) {
                    firstColumnCheck($scope.data.treeData, memoryChannelid).then(function(data) {
                        $scope.selectedNode = data;
                        deffer.resolve(data);
                    }, function() {
                        websiteLeftService.positionSelectChannel($scope.data.treeData, memoryChannelid, 1, $scope.expandedTest)
                            .then(function(selectedChannel) {
                                $scope.selectedNode = selectedChannel;
                                deffer.resolve(selectedChannel);
                            },function(){ 
                                $scope.selectedNode = $scope.data.treeData[0];
                                deffer.resolve($scope.selectedNode);
                            });
                    });
                } else {
                    for (var i = 0; i < $scope.data.treeData.length; i++) {
                        if ($scope.data.treeData[i].CHANNELID === $scope.status.widgetParams.channelid) {
                            $scope.selectedNode = $scope.data.treeData[i];
                            break;
                        }
                    }
                    deffer.resolve(data);
                }
                //$scope.status.ChannelId = $scope.selectedNode.CHANNELID;
                //requestDataPromise(true);
            });
            return deffer.promise;
        }
        /**
         * [initSelectedMap description]初始化选中map；防止过多的循环遍历
         */
        function initSelectedMap() {
            $scope.status.selectedArray = {};
            $scope.status.selectedMap = {};
            for (var i = 0; i < $scope.data.selectedDocuments.length; i++) {
                var key = $scope.data.selectedDocuments[i].recid;
                $scope.status.selectedMap[key] = true;
            }
        }
        /**
         * [deleteDoc description]删除稿件
         */
        function deleteDoc(item) {
            for (var i = 0; i < $scope.data.selectedDocuments.length; i++) {
                var selectedDoc = $scope.data.selectedDocuments[i];
                if (item.RECID === selectedDoc.recid) {
                    $scope.data.selectedDocuments.splice(i, 1);
                    break;
                }
            }
            delete $scope.status.selectedMap[item.RECID];
        }
        /**
         * [selectDoc description]选中稿件
         */
        function selectDoc(item) {
            if ($scope.data.selectedDocuments.length === $scope.status.documentsMaxCount) {
                modalDialog.alertType("选择稿件数不能超过" + $scope.status.documentsMaxCount + "条", "", "warning", false);
                return;
            }
            if ($scope.status.selectedMap[item.RECID]) return;
            var selectedItem = {
                title: item.TITLE,
                subtitle: item.HOMETITLE,
                url: item.DOCPUBURL,
                titlecolor: item.TITLECOLOR,
                abstract: item.ABSTRACT,
                isRelNews: true,
                recid: item.RECID,
                reltime: item.RELTIME,
                metadataId: item.METADATAID,
                source: item.source,
                author: item.author
            };
            $scope.data.selectedDocuments.unshift(selectedItem);
            $scope.status.selectedMap[item.RECID] = true;
        }
        /**
         * [selectAll description]列表稿件全选
         */
        function selectAll() { //新算法全选速度偏慢添加蒙层
            var deffer = $q.defer();
            var flag = $scope.checkSelectedAll();
            if (flag) {
                for (var i = 0; i < $scope.data.items.DATA.length; i++) {
                    deleteDoc($scope.data.items.DATA[i]);
                }
            } else {
                var limitLength = $scope.status.documentsMaxCount - $scope.data.selectedDocuments.length;
                for (var j = 0; j < $scope.data.items.DATA.length; j++) {
                    if (j > limitLength - 1) {
                        modalDialog.alertType("选择稿件数不能超过" + $scope.status.documentsMaxCount + "条", "", "warning", false);
                        break;
                    }
                    selectDoc($scope.data.items.DATA[j]);
                }
            }
            deffer.resolve();
            return deffer.promise;
        }
        /**
         * [initDropDownList description]初始化搜索条件下拉列表
         */
        function initDropDownList() {
            $scope.status.dropDownList = [{
                name: "标题",
                value: "title"
            }, {
                name: "ID",
                vaule: "id"
            }];
            $scope.status.searchSelected = angular.copy($scope.status.dropDownList[0]);
        }
        /**
         * [setSearchOptioin description]设置搜索条件
         */
        function setSearchOptioin(SearchByCondition) {
            if ($scope.status.isSearch !== true) {
                delete $scope.status.SearchValue;
                delete $scope.status.SearchRecId;
                delete $scope.status.SearchTitle;
            } else {
                if ($scope.status.searchSelected.value === "title") {
                    $scope.status.SearchTitle = $scope.status.SearchValue;
                    delete $scope.status.SearchRecId;
                } else {
                    $scope.status.SearchRecId = $scope.status.SearchValue;
                    delete $scope.status.SearchTitle;
                }
            }
        }
        /**
         * [memorySelectedChannel description]记忆选择过的栏目，方便下次操作
         */
        function memorySelectedChannel(channelid) {
            localStorageService.set("selectDocumentChannelMemory", channelid);
        }
        /**
         * [firstColumnCheck description]一级栏目选中检查
         */
        function firstColumnCheck(treeData, channelid) {
            var deffer = $q.defer();
            var flag = false;
            var selectedChannel;
            for (var i = 0; i < treeData.length; i++) {
                var data = treeData[i];
                if (data.CHANNELID === channelid) {
                    selectedChannel = data;
                    flag = true;
                    break;
                }
            }
            if (flag) {
                deffer.resolve(selectedChannel);
            } else {
                deffer.reject();
            }
            return deffer.promise;
        }
    }]);
